"use client";

import { Core, Decorative } from "@faire/design-tokens";
import React from "react";

import Color, { ColorsOrKeys } from "../Color";

import { SVGIcon } from "./SVGIcon";

const getPath = () => (
  <>
    <path d="M0 8.856H1.164V0.12H0V8.856Z" />
    <path d="M3.99803 8.856H5.12603V1.98L10.514 8.856H11.462V0.12H10.322V6.828L5.06603 0.12H3.99803V8.856Z" />
    <path d="M17.221 8.976C18.985 8.976 20.245 8.004 20.245 6.468V6.444C20.245 5.064 19.333 4.38 17.413 3.948C15.565 3.54 15.133 3.132 15.133 2.34V2.316C15.133 1.608 15.793 1.032 16.861 1.032C17.737 1.032 18.529 1.32 19.333 1.968L19.981 1.08C19.093 0.36 18.157 0 16.885 0C15.205 0 13.981 1.008 13.981 2.424V2.448C13.981 3.936 14.941 4.56 16.909 4.992C18.685 5.388 19.093 5.808 19.093 6.552V6.576C19.093 7.38 18.361 7.944 17.257 7.944C16.093 7.944 15.229 7.536 14.341 6.744L13.633 7.584C14.677 8.52 15.853 8.976 17.221 8.976Z" />
    <path d="M22.6289 8.856H23.7929V0.12H22.6289V8.856Z" />
    <path d="M26.6269 8.856H29.7349C32.4829 8.856 34.3789 6.948 34.3789 4.488V4.464C34.3789 2.004 32.4829 0.12 29.7349 0.12H26.6269V8.856ZM29.7349 1.176C31.8229 1.176 33.1669 2.628 33.1669 4.488V4.512C33.1669 6.384 31.8229 7.8 29.7349 7.8H27.7789V1.176H29.7349Z" />
    <path d="M36.7324 8.856H43.1524V7.812H37.8844V4.98H42.5284V3.936H37.8844V1.164H43.0924V0.12H36.7324V8.856Z" />
    <path d="M46.5953 4.536V1.176H49.1513C50.4833 1.176 51.2633 1.788 51.2633 2.82V2.844C51.2633 3.888 50.3993 4.536 49.1513 4.536H46.5953ZM45.4433 8.856H46.5953V5.568H48.9233L51.3353 8.856H52.7273L50.1473 5.364C51.4793 5.088 52.4273 4.224 52.4273 2.784V2.76C52.4273 2.064 52.1753 1.428 51.7313 0.996C51.1913 0.444 50.3273 0.12 49.2353 0.12H45.4433V8.856Z" />
  </>
);

const defaultSVGProps = {
  viewBox: "0 0 53 9",
  titleAccess: "Insider",
  // override the default width of 1em from SVGIconComponent
  width: "auto",
};

/**
 * Insider icon, with `asphalt` color.
 * @trackcomponent
 */
export const InsiderLightIcon = React.memo(({ color, ref, ...props }: SVGIcon.IProps & { color?: typeof Core.icon.subdued } & React.RefAttributes<SVGElement>) => (
    <SVGIcon
      ref={ref}
      color={color ?? Core.icon.subdued}
      {...defaultSVGProps}
      {...props}
    >
      {getPath()}
    </SVGIcon>
  )
);
if (process.env.NODE_ENV !== "production") {
  InsiderLightIcon.displayName = `InsiderIcon`;
}

type IconColor = ColorsOrKeys<"cabernet" | "asphalt" | "white">;

/**
 * Insider icon.
 * Defaults to `cabernet` color.
 * @trackcomponent
 */
export const InsiderIcon = React.memo(({ color = Decorative.shade.red, ref, ...props }: SVGIcon.IProps & { color?: IconColor } & React.RefAttributes<SVGElement>) => (
    <SVGIcon
      ref={ref}
      color={
        // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
        Color[color] ?? color
      }
      {...defaultSVGProps}
      {...props}
    >
      {getPath()}
    </SVGIcon>
  )
);
